import { NgModule } from '@angular/core';
import { ResendAccessCodeComponent } from '../resend-access-code/resend-access-code.component';
import { ViewAccessCodeComponent } from '../view-access-code/view-access-code.component';
import { ShipDetailsActionsComponent } from './ship-details-actions.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule, NgOptimizedImage } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        MatButtonModule,
        ResendAccessCodeComponent,
        ViewAccessCodeComponent,
        NgOptimizedImage,
    ],
  declarations: [ShipDetailsActionsComponent],
  providers: [],
  exports: [ShipDetailsActionsComponent],
})
export class ShipDetailsActionsModule {
}
